import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { ResultsData, ResultsSubscriptionData } from '../types';

export const isValidResults = (obj: ResultsData): boolean =>
  Boolean(obj?.data?.getResultsWidget && !isEmptyObject(obj.data.getResultsWidget));

export const isValidResultsSubscription = (obj: ResultsSubscriptionData): boolean =>
  Boolean(obj?.data?.onUpdateResultsWidgetByDay && !isEmptyObject(obj.data.onUpdateResultsWidgetByDay));